import { FunctionComponent } from 'preact';
import { Stack } from 'components/Stack';
import { CarrierLogo, CarrierName } from './DropOffCarrier.styles';
import { getCarrierLogo } from '../../utils';

const ICON_SIZE = 32;

interface DropOffCarrierProps {
  carrierId: string;
  carrierName?: string;
}

const DropOffCarrier: FunctionComponent<DropOffCarrierProps> = ({
  carrierId,
  carrierName,
}) => {
  const carrierLogoUrl = getCarrierLogo(carrierId);
  return (
    <Stack isFullWidth align="center" gap={8}>
      {/* Wrap within a div to prevent alt text from wrapping downwards if alt text is too long */}
      <div>
        <CarrierLogo
          width={ICON_SIZE}
          height={ICON_SIZE}
          alt={`${carrierName} carrier logo`}
          src={carrierLogoUrl}
        />
      </div>
      <CarrierName>{carrierName}</CarrierName>
    </Stack>
  );
};

export { DropOffCarrier };
